<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "Logging"
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/login/Logging.vue